module.exports = "fragment Error on Error {\n  __typename\n  code\n  message\n}\n"